import React from 'react';
import './About.css';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  
  const strengths = [
    {
      icon: 'fas fa-palette',
      title: t.about.strengths.design.title,
      description: t.about.strengths.design.desc
    },
    {
      icon: 'fas fa-rocket',
      title: t.about.strengths.delivery.title,
      description: t.about.strengths.delivery.desc
    },
    {
      icon: 'fas fa-cogs',
      title: t.about.strengths.automation.title,
      description: t.about.strengths.automation.desc
    },
    {
      icon: 'fas fa-robot',
      title: t.about.strengths.bots.title,
      description: t.about.strengths.bots.desc
    },
    {
      icon: 'fas fa-code',
      title: t.about.strengths.webdev.title,
      description: t.about.strengths.webdev.desc
    },
    {
      icon: 'fas fa-chart-line',
      title: t.about.strengths.growth.title,
      description: t.about.strengths.growth.desc
    }
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">{t.about.title}</h2>
            <p className="about-description">
              {t.about.description1}
            </p>
            <p className="about-description">
              {t.about.description2}
            </p>
            <p className="about-description">
              {t.about.description3}
            </p>
            <ul className="about-bullets">
              <li>{t.about.bullet1}</li>
              <li>{t.about.bullet2}</li>
              <li>{t.about.bullet3}</li>
            </ul>
            <p className="about-description">
              {t.about.description4}
            </p>
          </div>
          <div className="about-visual">
            <div className="about-illustration about-illustration--logo">
              <img src="/logo.png" alt={t.brand.logoAlt} className="about-logo-img" />
            </div>
          </div>
        </div>
        <div className="strengths-grid">
          {strengths.map((strength, index) => (
            <div key={index} className="strength-card">
              <div className="strength-icon">
                <i className={strength.icon}></i>
              </div>
              <h3 className="strength-title">{strength.title}</h3>
              <p className="strength-description">{strength.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;

